import { Navigation } from "lucide-react";
import { BUSINESS } from "@/data/business";

// "Get Directions in Apple Maps" deep link — opens the native Apple Maps app on
// iPhone/Mac and Apple Maps on the web elsewhere. No Apple account required.
export const AppleDirections = ({ className = "", variant = "solid" }) => {
  const href = `https://maps.apple.com/?daddr=${encodeURIComponent(BUSINESS.address)}`;
  const base =
    "inline-flex items-center justify-center gap-2 font-bold rounded-sm transition-colors px-5 py-2.5 text-sm";
  const styles =
    variant === "outline"
      ? "border border-slate-300 text-slate-800 hover:border-red-600 hover:text-red-700"
      : "bg-slate-900 text-white hover:bg-red-600";
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className={`${base} ${styles} ${className}`}
      data-testid="apple-directions-btn"
    >
      <Navigation className="h-4 w-4 shrink-0" />
      Get Directions (Apple Maps)
    </a>
  );
};
